export default "__VITE_ASSET__BLmOBzgR__"